import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { contactInfo } from '../../../mocks/contacto';

export default function MapSection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });

  return (
    <section ref={ref} className="w-full bg-white py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        <div className="text-center max-w-2xl mx-auto mb-14" style={style}>
          <span className="font-sans text-brand-gray-400 text-[11px] tracking-[0.2em] uppercase font-medium">
            Ubicación
          </span>
          <h2 className="font-serif text-brand-black text-[clamp(2rem,4vw,3rem)] font-semibold leading-[1.15] mt-4">
            Encuentra el <span className="italic text-brand-gray-300">Atelier</span>
          </h2>
          <p className="font-sans text-brand-gray-500 text-base leading-[1.8] mt-5">
            En pleno Eixample de Barcelona, a pasos de la Sagrada Familia y bien conectado
            con metro y bus.
          </p>
        </div>

        <div
          className="rounded-3xl overflow-hidden border border-brand-gray-200"
          style={isVisible ? {
            opacity: 1,
            transform: 'translateY(0px)',
            transition: 'opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms',
          } : {
            opacity: 0,
            transform: 'translateY(36px)',
            transition: 'opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms',
            willChange: 'opacity, transform',
          }}
        >
          <div className="relative w-full h-[350px] md:h-[480px]">
            <iframe
              src={contactInfo.mapUrl}
              title="Ubicación Atelier Anthony Sánchez Couture"
              className="w-full h-full border-0"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          <div className="p-6 md:p-8 bg-brand-gray-50 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <p className="font-serif text-brand-black text-lg font-medium">
                Rambla de Catalunya, 85, Principal - 2
              </p>
              <p className="font-sans text-brand-gray-500 text-sm mt-1">
                Eixample, 08008 Barcelona, España
              </p>
            </div>
            <a
              href={contactInfo.mapLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-brand-black text-white font-sans text-[13px] tracking-widest uppercase px-6 py-3 rounded-md hover:bg-brand-gray-800 transition-colors duration-300 whitespace-nowrap"
            >
              <i className="ri-navigation-line" />
              Cómo llegar
            </a>
          </div>
        </div>

        {/* Transport info */}
        <div
          className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4"
          style={isVisible ? {
            opacity: 1,
            transform: 'translateY(0px)',
            transition: 'opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 350ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 350ms',
          } : {
            opacity: 0,
            transform: 'translateY(24px)',
            transition: 'opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 350ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 350ms',
            willChange: 'opacity, transform',
          }}
        >
          {[
            {
              icon: 'ri-train-line',
              title: 'Metro',
              detail: 'L2/L5 Sagrada Familia',
            },
            {
              icon: 'ri-bus-line',
              title: 'Bus',
              detail: 'H8, 19, 50, V21',
            },
            {
              icon: 'ri-parking-line',
              title: 'Parking',
              detail: 'Sagrada Familia (200m)',
            },
          ].map((item) => (
            <div key={item.title} className="flex items-center gap-4 bg-brand-cream rounded-2xl p-5">
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-brand-black">
                <i className={`${item.icon} text-lg`} />
              </div>
              <div>
                <p className="font-sans text-brand-black text-sm font-medium">{item.title}</p>
                <p className="font-sans text-brand-gray-500 text-xs">{item.detail}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}